export const projectList = (state, rootState) => {
	return state.projectList;
}

export const projectStatusList = (state, rootState) => {
    return state.projectStatusList;
}

export const projectSpecifiers = (state, rootState) => {
	return state.projectSpecifiers;
}

export const projectVehicles = (state, rootState) => {
    return state.projectVehicles;
}

export const projectImages = (state, rootState) => {
    return state.projectImages;
}

export const objProjectStatusEdit = (state, rootState) => {
    return state.objProjectStatusEdit;
}

export const projectRegions = (state, rootState) => {
	return state.projectRegions;
}

export const projectRegionTypes = (state, rootState) => {
	return state.projectRegionTypes;
}

export const projectRegionSub = (state, rootState) => {
	return state.projectRegionSub;
}

export const projectRegionTown = (state, rootState) => {
	return state.projectRegionTown;
}

export const objProjectEdit = (state, rootState) => {
	return state.objProjectEdit;
}

export const projectPreLocations = (state, rootState) => {
	return state.projectPreLocations;
}

export const projectEditImages = (state, rootState) => {
	return state.projectEditImages;
}

export const projectTenderWinner = (state, rootState) => {
	return state.projectTenderWinner;
}

export const selectedNewLeadProject = (state, rootState) => {
	return state.selectedNewLeadProject;
}
